import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../../Components/ui/Button";
import { Checkbox } from "../../Components/ui/Checkbox";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../Components/ui/Form";
import { Input } from "../../Components/ui/Input";
import { login } from "../../lib/PB/Users";
import { useUserStore } from "../../store/UserStore";
import type { Login } from "../../Types/UserTypes";
import { loginschema } from "../../Types/UserTypes";

export const Route = createFileRoute("/Auth/Login")({
  component: Login,
});

export default function Login() {
  const form = useForm<Login>({
    resolver: zodResolver(loginschema),
  });
  const { setLoggedInUser, setIsLoggedIn } = useUserStore();
  const navigate = useNavigate();
  const onSubmit = async (values: Login) => {
    try {
      const user = await login(values.email, values.password);
      if (user.email) {
        console.log("user", user);
        setLoggedInUser(user);
        setIsLoggedIn(true);
        form.reset();
        navigate({
          to: "/Home",
        });
      }
    } catch (error) {
      console.error(error);
      // data.email.message
    }
  };

  const [passwordType, setPasswordType] = useState("password");

  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="space-y-8 bg-white shadow-md rounded px-8 pt-6 pb-8 m-4"
        >
          <FormField
            control={form.control}
            name="email"
            defaultValue={""}
            render={({ field }) => {
              return (
                <FormItem className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <FormLabel>Your Email</FormLabel>
                  <FormControl>
                    <Input placeholder="name@company.com" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <FormField
            control={form.control}
            name="password"
            defaultValue={""}
            render={({ field }) => {
              return (
                <FormItem className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <FormLabel>Your Password</FormLabel>
                  <FormControl>
                    <>
                      <Input
                        type={passwordType}
                        placeholder="********"
                        autoComplete="on"
                        {...field}
                      />
                      <div className="flex items-center space-x-2">
                        <Checkbox
                          id="terms"
                          onCheckedChange={(checked) => {
                            console.log("m", checked);
                            if (checked) setPasswordType("text");
                            else setPasswordType("password");
                          }}
                        />
                        <label
                          htmlFor="terms"
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          show password
                        </label>
                      </div>
                    </>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              );
            }}
          />
          <div className="flex justify-between">
            <Link
              to="/Auth/ForgetPassword"
              className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
            >
              Forgot password?
            </Link>
            <Button variant="default" type="submit">
              Sign In
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}
